import React from 'react';
import { isTrue } from '../../helpers/isTrue';
import { checkValues } from './validation';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { updateProfile } from '../Onboarding/components/queries';
import { showMessage } from '../../helpers/showMessage';
import Loading from '../../components/Loading';

class EditMainInfo extends React.Component {
    constructor(props) {
        super();

        this.changeView = this.changeView.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onFocus = this.onFocus.bind(this);

        this.state = {
            isOpen: false,
            showEditMode: false,
            name: props.name ?? '',
            errors: {},
            loading: false,
            savedName: props.name ?? '',
        };
    }

    changeView(isEditMode) {
        this.setState({ showEditMode: isEditMode });
    }

    updateCountries(value) {
        this.setState({ geo_location: value });
    }

    onChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({ [name]: value });
    }

    onFocus(e) {
        const key = e.target.name;
        const errors = { ...this.state.errors };
        delete errors[key];

        this.setState({ errors });
    }

    async onSubmit(e) {
        try {
            e.preventDefault();

            const errors = {};

            if (!this.state.name) {
                errors.name = 'This field is required';
            } else {
                delete errors.name;
            }

            if (!_.isEmpty(errors)) {
                this.setState({ errors });
            } else {
                this.setState({
                    loading: true,
                });
                const params = {
                    name: this.state.name,
                };

                const res = await updateProfile(params, this.props.csrf_token);
                const data = await res.json();
                if (res.status === 200) {
                    showMessage(data?.message ?? 'Information Updated', 'success');
                    this.changeView(false);
                    this.setState({ savedName: this.state.name });
                } else {
                    showMessage(data?.message ?? 'Something went wrong', 'error');
                }
            }
        } catch (err) {
            showMessage(err.message ?? 'Something went wrong', 'error');
            console.log(err);
        } finally {
            this.setState({
                loading: false,
            });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <>
                {/* form defined in html */}
                {this.state.showEditMode ? (
                    <>
                        <div className="edit-form inline" id="name-edit-inputs">
                            <div className="text-field mb-3" style={{ marginRight: '10px' }}>
                                <label htmlFor="name" className="form-label">
                                    {t('profile.main_info.user_full_name')}
                                </label>
                                <input
                                    name="name"
                                    type="text"
                                    id="name"
                                    className="form-control"
                                    onChange={this.onChange}
                                    value={this.state.name}
                                    onFocus={this.onFocus}
                                />
                                {this.state.errors['name'] && (
                                    <div className="error-message">{this.state.errors['name']}</div>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="user-details" id="name-user-details">
                        <div className="user-info row mb-2">
                            <strong className="col-md-4">
                                {t('profile.main_info.user_full_name')}
                            </strong>
                            <span className="col">{this.state.savedName || '-'}</span>
                        </div>
                    </div>
                )}

                <div className="buttons-wrapper">
                    {this.state.showEditMode ? (
                        <span id="name-edit-btns">
                            <button
                                type="button"
                                className="button button-outline button-primary button-icon"
                                onClick={() => this.changeView(false)}
                            >
                                <i className="icon-close"></i>
                            </button>
                            <button
                                type="submit"
                                className="button button-filled button-primary button-icon"
                                onClick={this.onSubmit}
                                disabled={this.state.loading}
                            >
                                {this.state.loading ? (
                                    <Loading onlyPreloader />
                                ) : (
                                    <i className="icon-check-icon"></i>
                                )}
                            </button>
                        </span>
                    ) : (
                        <button
                            type="button"
                            className="button button-filled button-primary button-icon"
                            id="name-edit-btn"
                            onClick={() => this.changeView(true)}
                        >
                            <i className="icon-edit"></i>
                        </button>
                    )}
                </div>
            </>
        );
    }
}

export default withTranslation()(EditMainInfo);
